/**
 * Whether this module renders its revamped UI. Inside `pages/PlanRevamp` the
 * answer is always yes.
 *
 * The original `pages/PlanPageDetailsOPZ` resolves the real LaunchDarkly flag
 * (`planPageUiRevamp` / `planPageUIRevamp`) and is untouched, so production
 * keeps its opt-in behaviour. This copy is the redesign itself, reached only
 * from the plan route that `navigation/index.tsx` now points at PlanRevamp —
 * consulting the flag here could only ever turn the redesign off *inside the
 * redesign module*, which is what left this route rendering the legacy plan
 * page, and (more subtly) what would have left the revamped shell filled with
 * legacy child variants had the flag been defined as false: every shared
 * component below reads `usePlanPageRevampVariant`, so a false flag mixes the
 * two designs on one screen rather than cleanly showing either.
 *
 * Keeping the exported names and signatures means the ~20 call sites across
 * this module need no changes.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPlanPageUiRevampEnabled = (flags?: Record<string, boolean | undefined>): boolean =>
  true;

export const usePlanPageUiRevamp = (): boolean => true;

/** Use with shared components that accept variant="revamp". */
export const usePlanPageRevampVariant = (variant: 'legacy' | 'revamp' = 'legacy'): boolean =>
  variant === 'revamp';
